<template>
  <div>
    <v-btn
      absolute
      dark
      fab
      top
      right
      color="primary"
      style="top:10px;"
      @click="toAddZone()"
      v-if="!isEditTransfer"
    >
      <v-icon color="black">add</v-icon>
    </v-btn>
    <zoneForm
      :dialog="zoneDialog"
      @setDialog="zoneDialog = $event"
      :editedIndex="editedIndex"
      @setEditIndex="editedIndex = $event"
      :transfer_zone_form="transfer_zone_form"
    />
    <v-layout row>
      <!-- <v-flex xs4></v-flex>
      <v-flex xs4>
        <v-spacer></v-spacer>
      </v-flex>-->
      <v-flex xs12>
        <v-toolbar dense flat>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search"
            single-line
            hide-details
            style="padding:0;"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :search="search"
      :headers="headers"
      :loading="loading_message"
      :items="transfer_zone_list"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ transfer_zone_list.indexOf(props.item)+1 }}</td>
        <td class="text-xs-center">{{ props.item.transport_zone_name_th }}</td>
        <td class="justify-center layout px-0">
          <v-tooltip top>
            <v-btn icon @click="editZone(props.item)" slot="activator">
              <v-icon small>{{!isEditTransfer ? 'edit' : 'remove_red_eye'}}</v-icon>
            </v-btn>
            <span>{{!isEditTransfer ? 'Edit' : 'View'}}</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              icon
              slot="activator"
              v-if="!isEditTransfer"
              @click="deleteZone(props.item,props.index)"
            >
              <v-icon small>delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>
        </td>
      </template>
      <template slot="no-data">
        <div class="text-xs-center" v-if="loading_message == false">No data available</div>
        <div class="text-xs-center" v-else>
          <v-progress-circular :size="30" color="primary" indeterminate></v-progress-circular>Loading data ...
        </div>
      </template>
    </v-data-table>
    <!-- 
    <div class="text-xs-center py-2">
      <v-pagination circle v-model="pagination.page" :length="pages"></v-pagination>
    </div>-->
  </div>
</template>

<script>
import zoneForm from "./ZoneForm";
import { mapState, mapGetters } from "vuex";
export default {
  data: () => ({
    search: "",
    loading_message: false,
    transfer_zone_form: {},
    zoneDialog: false,
    dialog: false,
    editedIndex: -1,
    pagination: {
      rowsPerPage: 10
    },
    headers: [
      {
        text: "ID",
        align: "center",
        sortable: false,
        value: "name"
      },
      {
        text: "Zone name",
        align: "center",
        value: "transport_zone_name_th",
        sortable: false
      },
      {
        text: "Action",
        align: "center",
        value: "name",
        sortable: false
      }
    ]
  }),
  components: {
    zoneForm
  },
  computed: {
    ...mapState({
      transfer_zone_list: state => state.fetchFoodZoneBack.transfer_zone_list
    }),
    ...mapGetters({
      isEditTransfer: "isEditTransfer"
    }),
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  async created() {
    this.loading_message = true;
    await this.$store.dispatch("fetchFoodZoneBack/getTransferZoneList");
    this.loading_message = false;
  },
  methods: {
    async deleteZone(item, index) {
      var r = confirm("Press a button!");
      if (r == true) {
        let check = await this.$store.dispatch(
          "fetchFoodZoneBack/deleteTransferZone",
          item.transport_zone_id
        );
        if (check != false) {
          this.transfer_zone_list.splice(index, 1);
        }
      }
    },
    setTransferZoneForm() {
      this.transfer_zone_form = {
        transport_zone_name_th: null,
        transport_zone_name_en: null,
        transport_zone_name_cn: null,
        transport_zone_note: null,
        transport_zone_sub_district: []
      };
    },
    toAddZone() {
      this.setTransferZoneForm();
      this.zoneDialog = true;
    },
    async editZone(item) {
      this.transfer_zone_form = {};
      this.transfer_zone_form.transport_zone_id = item.transport_zone_id;
      this.zoneDialog = true;
      this.editedIndex = 1;
      this.transfer_zone_form = await this.$store.dispatch(
        "fetchFoodZoneBack/getTransferZoneDetail",
        this.transfer_zone_form.transport_zone_id
      );
    }
  }
};
</script>

